import { render, staticRenderFns } from "./CExternalLinkMediatorModal.vue?vue&type=template&id=4d87ecae&"
import script from "./CExternalLinkMediatorModal.vue?vue&type=script&lang=ts&"
export * from "./CExternalLinkMediatorModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports